<template>
    <!-- Navigation -->
    <nav class="navbar navbar-expand-md navbar-dark navbar-custom fixed-top">
        <a class="navbar-brand logo-image" href="index.html">
          <img src="../assets/images/branding/ArcaneFullWhite.png">
        </a>

        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
            <li class="nav-item active">
                <a class="nav-link" href="https://arcanespectacles.com">Home <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="/shop">Shop</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="/faq">FAQ</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="/about">About Us</a>
            </li>
            <!-- <li class="nav-item">
                <a class="nav-link" href="/contact">Contact</a>
            </li> -->
            </ul>
        </div> 
       
        <!-- <div class="navbar-nav ml-auto" id="navbarsExampleDefault">
            <ul class="navbar-nav ml-auto"></ul>
            <span class="nav-item social-icons">
                <span class="fa-stack">
                    <a href="https://twitter.com/ArcaneSpectacle">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="fab fa-twitter fa-stack-1x"></i>
                    </a>
                </span>
            </span>
        </div> -->
    </nav> <!-- end of navbar -->
    <!-- end of navigation -->
</template>

<script>
export default {
  name: 'NavSection'
}
</script>


// WEBPACK FOOTER //
// src/components/NavSection.vue